import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import 'bootstrap/dist/css/bootstrap.min.css';

import './index.scss';

import App from './App';
import config from './config';
import * as serviceWorker from './serviceWorker';

import authReducer from './store/reducers/auth';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
    auth: authReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

Amplify.configure({
	Auth: {
		mandatorySignIn: true,
		region: config.cognito.REGION,
		userPoolId: config.cognito.USER_POOL_ID,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID,
	},
	API: {
		endpoints: [
			{
				name: 'users',
				endpoint: config.apiGateway.URL + '/users',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_disable',
				endpoint: config.apiGateway.URL + '/user_disable',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_enable',
				endpoint: config.apiGateway.URL + '/user_enable',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_confirm',
				endpoint: config.apiGateway.URL + '/user_confirm',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_reset_pwd',
				endpoint: config.apiGateway.URL + '/user_reset_pwd',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_update',
				endpoint: config.apiGateway.URL + '/user_update',
				region: config.apiGateway.REGION,
			},
			{
				name: 'settings',
				endpoint: config.apiGateway.URL + '/settings',
				region: config.apiGateway.REGION,
			},
			{
				name: 'asset',
				endpoint: config.apiGateway.URL + '/asset',
				region: config.apiGateway.REGION,
			},
			{
				name: 'asset_projection',
				endpoint: config.apiGateway.URL + '/asset_projection',
				region: config.apiGateway.REGION,
			},
			{
				name: 'assets_connections',
				endpoint: config.apiGateway.URL + '/assets_connections',
				region: config.apiGateway.REGION,
			},
			{
				name: 'list_asset',
				endpoint: config.apiGateway.URL + '/list_asset',
				region: config.apiGateway.REGION,
			},
			{
				name: 'counts',
				endpoint: config.apiGateway.URL + '/counts',
				region: config.apiGateway.REGION,
			},
			{
				name: 'hourly_counts',
				endpoint: config.apiGateway.URL + '/hourly_counts',
				region: config.apiGateway.REGION,
			},
			{
				name: 'asset_last_hr',
				endpoint: config.apiGateway.URL + '/asset_last_hr',
				region: config.apiGateway.REGION,
			},
			{
				name: 'location',
				endpoint: config.apiGateway.URL + '/location',
				region: config.apiGateway.REGION,
			},
			{
				name: 'permissions',
				endpoint: config.apiGateway.URL + '/permissions',
				region: config.apiGateway.REGION,
			},
			{
				name: 'custom_permissions',
				endpoint: config.apiGateway.URL + '/custom_permissions',
				region: config.apiGateway.REGION,
			},
			{
				name: 'custom_permission_list',
				endpoint: config.apiGateway.URL + '/custom_permission_list',
				region: config.apiGateway.REGION,
			},
			{
				name: 'global_custom_permission_list',
				endpoint: config.apiGateway.URL + '/global_custom_permission',
				region: config.apiGateway.REGION,
			},
			
			{
				name: 'global_custom_permission',
				endpoint: config.apiGateway.URL + '/global_custom_permission',
				region: config.apiGateway.REGION,
			},
			{
				name: 'profile_det',
				endpoint: config.apiGateway.URL + '/profile_det',
				region: config.apiGateway.REGION,
			},
			{
				name: 'upd_custom_permissions',
				endpoint: config.apiGateway.URL + '/upd_custom_permissions',
				region: config.apiGateway.REGION,
			},
			{
				name: 'user_assets',
				endpoint: config.apiGateway.URL + '/user_assets',
				region: config.apiGateway.REGION,
			},
			{
				name: 'company',
				endpoint: config.apiGateway.URL + '/company',
				region: config.apiGateway.REGION,
			},
			{
				name: 'hourly_queue',
				endpoint: config.apiGateway.URL + '/hourly_queue',
				region: config.apiGateway.REGION,
			},
			{
				name: 'class_counts',
				endpoint: config.apiGateway.URL + '/class_counts',
				region: config.apiGateway.REGION,
			},
			{
				name: 'daily_counts',
				endpoint: config.apiGateway.URL + '/daily_counts',
				region: config.apiGateway.REGION,
			},
			{
				name: 'daily_class_counts',
				endpoint: config.apiGateway.URL + '/daily_class_counts',
				region: config.apiGateway.REGION,
			},
			{
				name: 'diagnostic',
				endpoint: config.apiGateway.URL + '/diagnostic',
				region: config.apiGateway.REGION,
			},
			{
				name: 'hourly_diagnose',
				endpoint: config.apiGateway.URL + '/hourly_diagnose',
				region: config.apiGateway.REGION,
			},
			{
				name: 'sites',
				endpoint: config.apiGateway.URL + '/sites',
				region: config.apiGateway.REGION,
			},
			{
				name: 'hourly_air_quality',
				endpoint: config.apiGateway.URL + '/hourly_air_quality',
				region: config.apiGateway.REGION,
			},
			{
				name: 'site_assets',
				endpoint: config.apiGateway.URL + '/site_assets',
				region: config.apiGateway.REGION,
			},
			{
				name: 'red_light',
				endpoint: config.apiGateway.URL + '/red_light',
				region: config.apiGateway.REGION,
			},
			{
				name: 'red_light_det',
				endpoint: config.apiGateway.URL + '/red_light_det',
				region: config.apiGateway.REGION,
			},
			{
				name: 'img',
				endpoint: config.apiGateway.URL + '/img',
				region: config.apiGateway.REGION,
			},
			{
				name: 'hourly_counts_speed',
				endpoint: config.apiGateway.URL + '/hourly_counts_speed',
				region: config.apiGateway.REGION,
			},
			{
				name: 'assets_connections',
				endpoint: config.apiGateway.URL + '/assets_connections',
				region: config.apiGateway.REGION,
			}
		]
	}
});

ReactDOM.render(
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
